<template>
  <div :id="id" class="g2-wrap" :style="wrap">
    <div id="g2-wrap"></div>
  </div>
</template>
<script>
import {GroupColumn} from '@antv/g2plot'
const component = {
  name: "hex-g2",
  props: {
    id: String,
    st: Object,
    listdata: {},
    name: String,
    value: String,
    group: String,
    title: String
  },
  data() {
    return {
      columnPlot: {},
      setting: {
        title: {
          visible: true,
          text: this.title
        },
        forceFit: true,
        height: parseInt(this.st.height),
        width: parseInt(this.st.width),
        data: this.listdata,
        xField: this.name,
        yField: this.value,
        yAxis: {
          min: 0
        },
        label: {
          visible: true
        },
        groupField: this.group
      }
    };
  },
  computed: {
    wrap() {
      let final = JSON.parse(JSON.stringify(this.st));
      return process.env.MODE === "editor" ? final : "";
    }
  },
  methods: {
    updateConfig() {
      this.columnPlot.updateConfig(this.setting);
    },
    loadJS(url, callback) {
      let script = document.createElement("script")
      let fn = callback || function() {};
      script.type = "text/javascript";
      if (script.readyState) {
        script.onreadystatechange = function() {
          if (
            script.readyState == "loaded" ||
            script.readyState == "complete"
          ) {
            script.onreadystatechange = null;
            fn();
          }
        };
      } else {
        script.onload = function() {
          fn();
        };
      }
      script.src = url;
      document.getElementsByTagName("head")[0].appendChild(script);
    }
  },
  watch: {
    listdata(n) {
      this.columnPlot.changeData(n);
    },
    name() {
      this.updateConfig();
    },
    value() {
      this.updateConfig();
    },
    group() {
      this.updateConfig();
    },
    title() {
      this.updateConfig();
    },
    st: {
      deep: true,
      handler(n, o) {
        if (n.width !== o.width || n.height !== o.height) {
          this.updateConfig();
        }
      }
    }
  },
  ready() {
    // this.loadJS('https://hexyun.oss-cn-beijing.aliyuncs.com/resource/5e4b5ab5a6ff4a554d53c059/a00cd7d6d42ee1027f4a9625433ff85c.js', ()=>{
      this.columnPlot = new GroupColumn(
        document.getElementById("g2-wrap"),
        this.setting
      );
      this.columnPlot.render();
    // })
  }
};
// 区分editor和实际打包， build之后的lib不打包
if (process.env.MODE === "editor") {
  component.define = require("./define");
}
export default component;
</script>

<style lang="less" scoped></style>



// WEBPACK FOOTER //
// index.vue?7d5a7dbc